import React from "react";

// Material-UI
import { Container, Grid, makeStyles, Typography, Box } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Card from "@material-ui/core/Card";
// Components
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import Footer from "../components/Footer";
import ApaItuPCAB from "../components/ApaItuPCAB";
import TimelinePCAB from "../components/TimelinePCAB";
import PeraturanPCAB from "../components/PeraturanPCAB";
// Data
import DataPengumuman from "../data/DataPengumuman";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  section: {
    margin: theme.spacing(2, 0),
  },
  card: {
    minHeight: 80,
  },
}));

const SelamatDatang = ({ classes }) => {
  return (
    <Container className={classes.section}>
      <Card elevation={3}>
        <Alert variant="filled" severity="success">
          <AlertTitle>{"Selamat Datang Calon Anggota Baru"}</AlertTitle>
          <Typography variant="body2">
            {
              "Pada Sistem Informasi Penerimaan Calon Anggota Baru (PCAB) Korps Sukarelawan Unit Universitas Negeri Jakarta"
            }
          </Typography>
        </Alert>
      </Card>
    </Container>
  );
};

const Pengumuman = ({ classes }) => {
  const pengumuman = DataPengumuman.map((data) => (
    <Grid item xs={12} sm={12} md={6} key={data.id}>
      <Card elevation={3}>
        <Alert variant="filled" severity={data.status} className={classes.card}>
          <AlertTitle>{data.title}</AlertTitle>
          <Typography variant="body2">{data.text}</Typography>
        </Alert>
      </Card>
    </Grid>
  ));
  return (
    <section id="list-pengumuman">
      <Container className={classes.section}>
        <Grid container spacing={2}>
          {pengumuman}
        </Grid>
      </Container>
    </section>
  );
};

const UserBeranda = () => {
  const classes = useStyles();
  return (
    <section id="user-beranda" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Beranda" />
        <SelamatDatang classes={classes} />
        <Box mt={2} mb={2}>
          <ApaItuPCAB/>
        </Box>
        <Box mt={2} mb={2}>
          <TimelinePCAB/>
        </Box>
        <PeraturanPCAB/>
        <Pengumuman classes={classes} />
      </Container>
      <Footer />
    </section>
  );
};

export default UserBeranda;
